import { PipelineStepInstance, PipelineStepType } from './pipelineBuilder.types'
import { PIPELINE_STEP_ORDER } from './stepCatalog'

export function catalogOrderIndex(type: PipelineStepType): number {
    return PIPELINE_STEP_ORDER.indexOf(type)
}

/** Preset load / reset — canonical catalog order. */
export function sortStepsByCatalogOrder(
    steps: PipelineStepInstance[],
): PipelineStepInstance[] {
    return [...steps].sort(
        (a, b) => catalogOrderIndex(a.type) - catalogOrderIndex(b.type),
    )
}

/** Runtime display order (bench + enabled flow). */
export function sortStepsByOrder(
    steps: PipelineStepInstance[],
): PipelineStepInstance[] {
    return [...steps].sort((a, b) => a.order - b.order)
}

export function getEnabledStepsInOrder(
    steps: PipelineStepInstance[],
): PipelineStepInstance[] {
    return sortStepsByOrder(steps).filter((s) => s.enabled)
}

export function renumberStepsInCatalogOrder(
    steps: PipelineStepInstance[],
): PipelineStepInstance[] {
    return sortStepsByCatalogOrder(steps).map((step, index) => ({
        ...step,
        order: index + 1,
    }))
}

export function renumberEnabledBenchOrder(
    enabledSteps: PipelineStepInstance[],
    allSteps: PipelineStepInstance[],
): PipelineStepInstance[] {
    const enabledIds = new Set(enabledSteps.map((s) => s.id))
    const enabledOrder = new Map(
        enabledSteps.map((step, index) => [step.id, index + 1]),
    )
    const disabled = sortStepsByOrder(
        allSteps.filter((s) => !enabledIds.has(s.id)),
    )
    const disabledStart = enabledSteps.length + 1

    return allSteps.map((step) => {
        if (enabledOrder.has(step.id)) {
            return { ...step, order: enabledOrder.get(step.id)! }
        }
        const disabledIndex = disabled.findIndex((d) => d.id === step.id)
        return {
            ...step,
            order: disabledStart + disabledIndex,
        }
    })
}

export function insertStepAtCatalogPosition(
    steps: PipelineStepInstance[],
    newStep: PipelineStepInstance,
): PipelineStepInstance[] {
    const sorted = sortStepsByCatalogOrder([...steps, newStep])
    return sorted.map((step, index) => ({
        ...step,
        order: index + 1,
    }))
}
